<!--
 * @Description: 不可编辑详情页
 * @Author: ll
 * @Date: 2021-9-9 9:32:30
 * @LastEditTime: 
 * @LastEditors: ll
-->
<template>
  <div ref="cr-cannotEdit" class="cr-cannotEdit cr-bg-white-1 cr-fs-md">
    <cr-loading :loading="loading"></cr-loading>
    <!-- 头部 -->
    <div class="cr-jc-between cr-mb-3">
      <h2 class="cr-fs-lg cr-text-black-1 cr-bold">软件著作权登记</h2>
      <router-link to="/businessCenter/caseManage">案件列表>></router-link>
    </div>
    <div class="cr-ai-center cr-text-black-1 cr-mb-1">
      材料：
      <div>
        <a v-for="(attachment, index) in attachments" :key="index" :href="attachment.attachmentUrl">《{{ attachment.attachmentName }}》</a>
      </div>
    </div>
    <!-- 内容框 -->
    <div class="card-info cr-mb-3">
      <div class="head cr-jc-between cr-ai-center">
        <div class="cr-flex cr-fs-md cr-text-grey-1 cr-cursor">
          <span>案件号：</span>
          <a-tooltip placement="topLeft" title="点击复制">
            <span class="cr-block cr-pr-2 cr-fs-ellipsis cr-cursor" v-copy="overviewData.caseNo" @click="copySuccess">{{ overviewData.caseNo + ' (' + overviewData.createdAt + ')' }}</span>
          </a-tooltip>
        </div>
        <div class="cr-fs-md cr-text-grey-1 cr-cursor" @mouseenter="hoverPhone = true" @mouseleave="hoverPhone = false">
          联系人：
          <a-tooltip placement="topLeft" title="点击复制">
            <span class="cr-cursor" v-copy="overviewData.userName" @click="copySuccess">{{ overviewData.userName || '' }}</span>
          </a-tooltip>
          -
          <a-tooltip placement="topLeft" title="点击复制">
            <span class="cr-cursor" v-copy="overviewData.userPhone" @click="copySuccess">{{ overviewData.userPhone || '' }}</span>
          </a-tooltip>
        </div>
      </div>
      <div class="content cr-flex">
        <div class="left">
          <p class="cr-bold cr-text-black-1">{{ overviewData.fullName }}</p>
          <p class="cr-text-grey-2">
            {{ overviewData.coprType == 1 ? '软件著作权' : '' }} <span class="cr-text-aaa" v-show="overviewData.processType || overviewData.processCycle">（{{ overviewData.processType == 1 ? '移动App在线登记' : '计算机软件著作权登记' }} {{ overviewData.processCycle }}）</span>
          </p>
          <p class="tip">{{ getChildState(overviewData.childState) }}</p>
          <p>
            <span class="cr-text-black-1 cr-mr-1">¥ {{ (overviewData.amount / 100).toFixed(2) }}</span>
            <span class="cr-state" v-if="overviewData.transState === 0">待付款</span>
            <span class="cr-state" v-if="overviewData.transState === 1">已付款</span>
            <span class="cr-state" v-if="overviewData.transState === -1">待退款</span>
            <span class="cr-state" v-if="overviewData.transState === -2">已退款</span>
            <span class="cr-text-aaa" v-show="overviewData.payTime || overviewData.paidMethod">（{{ overviewData.payTime }} {{ getPaidMethod(overviewData.paidMethod) }}）</span>
          </p>
        </div>
        <div class="right">
          <div class="cr-ai-center cr-mb-2">
            <div class="item" v-for="(over, index) in overviewData.stateLogs" :key="index" :class="{ active: index + 1 === overviewData.state }">{{ over.state }}{{ over.startingDate }}</div>
          </div>
          <div class="fun-list">
            <div class="cr-ai-center cr-mb-1" v-for="(over, index) in overviewData.optLogInfos" :key="index">
              <span class="dot" />
              <span class="cr-in-block cr-text-aaa cr-dates">{{ over.date }}</span>
              <span class="cr-text-grey-2">{{ over.content }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <detail-cont v-if="caseNo" :caseNo="caseNo" />
    <div class="cr-footer cr-pr-2 cr-jc-end cr-ai-center">
      <a-button type="primary" v-show="overviewData.childState == 32" @click="checkVisible = true">确认核对表</a-button>
      <a-button type="primary" v-show="overviewData.childState == 35" @click="downMaterials">下载邮寄说明</a-button>
      <a-button type="primary" @click="shareModal = true">分享客户</a-button>
    </div>
    <!-- 复制链接 -->
    <a-modal v-model="shareModal" width="460px" title="链接已复制" :footer="null">
      <div class="share-modal-content">
        <p class="case-no">案件号：{{ caseNo }}</p>
        <p class="case-desc">版权登记链接已复制，您可以直接分享给客户。</p>
        <div class="case-url">
          <div class="url cr-fs-ellipsis">{{ fullpath }}</div>
          <a-button type="primary" v-copy="fullpath" class="btn" @click="copySuccess">复制链接</a-button>
        </div>
        <div class="footer">
          <a-button type="primary" ghost @click="shareModal = false">好的，知道了</a-button>
        </div>
      </div>
    </a-modal>
    <!-- 确认核对表 -->
    <check-list :checkVisible.sync="checkVisible" v-if="caseNo && overviewData.childState == 32" :caseNo="caseNo" />
  </div>
</template>

<script>
import checkList from './component/checklist.vue'
import { overview, downloadMaterials, attachments } from '@/api/cannotEdit.js'
import DetailCont from './component/detailCont.vue'
export default {
  data() {
    return {
      overviewData: {},
      caseNo: '',
      checkVisible: false,
      loading: false,
      hoverCase: false,
      hoverPhone: false,
      fullpath: '',
      shareModal: false,
      attachments: []
    }
  },
  created() {
    this.init()
    this.toCopy()
  },
  mounted() {
    document.querySelector('.layout-content').scrollTop = 0
  },
  components: {
    DetailCont,
    checkList
  },
  methods: {
    async init() {
      this.loading = true
      this.caseNo = this.$route.query.caseNo
      const res = await overview(this.caseNo)
      const res1 = await attachments(this.caseNo)
      this.attachments = res1.data[0].attachments
      this.overviewData = res.data
      this.loading = false
    },
    toCopy() {
      let environment = process.env.NODE_ENV == 'production' ? 'https://bq.gongsibao.com' : 'https://bqtest.gongsibao.com'
      this.fullpath = `${environment}/cannotShare?caseNo=${this.caseNo}`
    },
    // 判断案件状态
    getChildState(state) {
      switch (state) {
        case 10:
          return '待付款'
        case 20:
          return '待补充信息'
        case 30:
          return '待平台审核'
        case 31:
          return '平台审核未通过'
        case 32:
          return '待客户确认表'
        case 33:
          return '确认表有误'
        case 34:
          return '业务待处理'
        case 35:
          return '材料待邮寄'
        case -30:
          return '待退款'
        case 40:
          return '已递交官方'
        case 41:
          return '下发补正通知书'
        case 42:
          return '已下证'
        case 43:
          return '已完成'
        case -40:
          return '已退款'
        default:
          break
      }
    },
    // 支付方式
    getPaidMethod(type) {
      switch (type) {
        case 'wechat_qr':
          return '微信支付'
        case 'alipay_qr':
          return '支付宝支付'
        case 'gateway_pub':
          return '网银支付_对公'
        case 'gateway_pri':
          return '网银支付_对私'
        case 'balance_pay':
          return '余额支付'
        case 'init_sync':
          return '期初同步'
        default:
          break
      }
    },
    //复制成功的提示信息
    copySuccess() {
      this.$message.success('复制成功！')
    },
    // 分享客户
    toJump() {
      this.$router.push({
        path: '/cannotShare',
        query: {
          caseNo: this.caseNo
        }
      })
    },
    // 下载邮寄材料
    async downMaterials() {
      let data = {
        caseNo: this.caseNo,
        fullName: this.overviewData.fullName
      }
      console.log(data)
      const res = await downloadMaterials(data)
      console.log(res)
    }
  }
}
</script>

<style lang="less" scoped>
.cr-cannotEdit {
  padding: 20px;
  .cr-text-aaa {
    color: #aaa !important;
  }
  .cr-text-ff {
    color: #1664ff;
  }
  .cr-text-f7 {
    color: #0072f7;
  }
  .card-info {
    width: 100%;
    height: 190px;
    border: 1px solid #f0f0f0;
    border-radius: 1px;
    .head {
      height: 40px;
      background: #fafafa;
      padding: 0 10px;
    }
    .content {
      height: 150px;
      .left {
        flex-basis: 370px;
        box-sizing: border-box;
        margin: 15px;
        border-right: 1px solid #f0f0f0;
        p {
          line-height: 25px;

          .cr-state {
            width: 56px;
            height: 22px;
            border-radius: 2px;
            display: inline-block;
            background: rgba(71, 186, 144, 0.1);
            color: #47ba90;
            text-align: center;
            line-height: 22px;
          }
        }
        .tip {
          font-size: 20px;
          color: #eeaa00;
          line-height: 32px;
        }
      }
      .right {
        flex: 1;
        overflow-y: auto;
        box-sizing: border-box;
        margin: 16px 16px 16px 0;
        .item {
          width: 162px;
          height: 20px;
          text-align: center;
          font-size: 14px;
          line-height: 20px;
          border-radius: 10px;
          background: #f0efef;
          color: #999;
          &.active {
            background: #47ba90;
            color: #fff;
          }
        }
        .fun-list {
          .dot {
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: @theme-color;
            margin-right: 10px;
          }
          .cr-dates {
            min-width: 130px;
          }
        }
      }
    }
  }
  .cr-footer {
    border-top: 1px solid #f0f0f0;
    width: 100%;
    height: 60px;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    .ant-btn {
      margin-right: 10px;
    }
  }
}
.share-modal-content {
  .case-no {
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
  }
  .case-desc {
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    margin-top: 14px;
  }
  .case-url {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .url {
      width: 304px;
      height: 40px;
      background: @item-selected;
      border-radius: 2px;
      line-height: 40px;
      padding: 0 10px;
      margin-right: 10px;
    }
    .btn {
      height: 40px;
      flex: 1;
    }
  }
  .footer {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
